import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import BlueButton from "../../BlueButton/BlueButton.js";
import Api from "../../../Api.js";
import {word} from '../../../word.js'
import {managerProfileRequest} from "../../../store/actions/manager.js";
import Cookies from 'js-cookie';
import SuccessToast from "../../BlueButton/SuccessToast.js";
import ErrorToast from "../../BlueButton/ErrorToast.js";

const Email = ({ close }) => {
    const dispatch = useDispatch();
    const login = useSelector((state) => state.manager.employee);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [code, setCode] = useState("");
    const [codeShow, setCodeShow] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [submit, setSubmit] = useState(false);
    const validateEmail = (email) => /^[\w.%+-]+@[\w-]+\.[\w]{2,}$/.test(email);
    const validatePassword = (password) => password.length >= 6;
    const validateCode = (code) => code.length >= 6;

    const handleSubmit = async () => {
        setSubmit(true);
        setDisabled(true);
        if (!codeShow) {
            if (!validateEmail(email) || !validatePassword(password)) {
                setDisabled(false);
                return;
            }
            const form = {
                email,
                password,
                old_email: login.user.email,
            };

            try {
                const {data} = await Api.emailVerification({...form, id:Cookies.get("id")});
                if (data.message) {
                    const text = data.message === "email already exists" ? "էլ հասցեն արդեն գոյություն ունի" : "Գաղտնաբառը սխալ է";
                    ErrorToast(text);
                } else {
                    setCodeShow(true);
                    SuccessToast();
                }
            } catch (err) {
                ErrorToast("Սխալ տեղի ունեցավ");
            } finally {
                setDisabled(false);
            }
        } else {
            if (!validateCode(code)) {
                setDisabled(false);
                return;
            }

            const newData = {
                email,
                password,
                old_email: login.user.email,
                code,
            };
            const {data} = await Api.checkEmailVerification({...newData, id:Cookies.get("id")});
            localStorage.setItem('token',data.token)
            await dispatch(managerProfileRequest({prof:Cookies.get("profession")}))

        }
    };

    return (
        <div className="settings-item">
            {!codeShow ? (
                <Form>
                    <Form.Group className="justify-content-center form-group">
                        <Form.Control
                            placeholder="Նոր էլ հասցե"
                            className={!validateEmail(email) && submit ? "form-control is-invalid" : "form-control"}
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {!validateEmail(email) && submit && <div className="validation valid-center">
                            <span>{word.email_error}</span>
                        </div>}
                    </Form.Group>
                    <Form.Group className="justify-content-center form-group">
                        <Form.Control
                            placeholder="Գաղտնաբառ"
                            className={!validatePassword(password) && submit ? "form-control is-invalid" : "form-control"}
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {!validatePassword(password) && submit && <div className="validation valid-center">
                            <span>{word.password_error}</span>
                        </div>}
                    </Form.Group>
                </Form>
            ) : (
                <Form>
                    <Form.Group className="justify-content-center form-group">
                        <Form.Control
                            placeholder="Կոդ"
                            className={!validateCode(code) && submit ? "form-control is-invalid" : "form-control"}
                            type="number"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />
                        {!validateCode(code) && submit && <div className="validation valid-center">
                            <span>{word.password_error}</span>
                        </div>}
                    </Form.Group>
                </Form>
            )}

            <BlueButton
                disabled={disabled}
                onChangeValue={handleSubmit}
                title="Հաստատել"
            />
        </div>
    );
};

export default Email;
